var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationLogistics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 565,
    height: 605,
    viewBox: "0 0 565 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_987)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M225.252 563.139C117.393 547.507 51.9234 471.096 37.2112 380.156C28.108 324.249 38.2226 262.918 69.3022 206.736C151.047 59.0616 357.662 55.6594 357.662 55.6594C476.555 49.7745 453.107 250.504 446.211 293.814C442.533 316.709 465.705 347.329 489.704 380.156C510.945 409.213 533.013 440.108 537.611 468.889C547.541 530.037 399.316 588.389 225.252 563.139Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.252 564.427C117.393 548.795 51.9233 472.383 37.2111 381.443H489.796C511.129 410.5 533.105 441.396 537.702 470.176C547.541 531.324 399.316 589.713 225.252 564.427Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.252 564.427C117.393 548.795 51.9233 472.383 37.2111 381.443H489.796C511.129 410.5 533.105 441.396 537.702 470.176C547.541 531.324 399.316 589.713 225.252 564.427Z",
    fill: "url(#paint0_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M226.539 486.176C221.114 486.084 214.586 485.348 212.103 480.475C210.908 478.084 211 475.234 210.632 472.475C206.954 448.292 164.656 449.395 157.668 425.948C157.116 423.925 156.84 421.442 158.311 419.879C159.599 418.5 161.622 418.224 163.461 418.132L224.976 413.81C227.459 404.707 217.712 396.983 208.793 394.133C168.61 381.259 123.002 407.741 83.463 392.753C81.3481 391.926 79.1412 390.914 78.1298 388.891C75.2793 383.098 84.3825 379.053 90.911 378.961L246.493 376.478C249.803 376.386 253.113 376.386 256.24 377.397C261.021 378.961 264.699 382.823 268.193 386.501C282.906 402.224 298.169 418.224 317.479 427.879C352.881 445.533 395.178 439.005 434.074 446.453C445.292 448.66 459.084 456.384 456.326 467.418C447.498 502.176 381.937 489.118 358.398 488.659L226.539 486.176Z",
    fill: "#1D2741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.063 101.543L401.155 131.795L413.016 162.875L422.671 158.277C423.876 157.7 425.255 157.597 426.532 157.989C427.81 158.381 428.893 159.238 429.568 160.392L432.142 164.898C432.602 165.682 432.903 166.55 433.027 167.451C433.151 168.352 433.097 169.269 432.866 170.148C432.635 171.028 432.233 171.854 431.683 172.578C431.133 173.302 430.445 173.911 429.66 174.369L429.384 174.553C422.395 178.231 408.235 187.058 405.568 187.058C401.523 187.058 389.753 168.852 389.753 168.852L401.063 101.543Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.441 158.001C426.441 158.001 422.12 161.404 424.143 165.082C426.165 168.76 433.062 168.944 433.062 168.944C433.062 168.944 438.671 158.921 426.441 158.001Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.476 137.404C431.621 137.624 433.743 138.024 435.821 138.6L445.383 140.898C445.867 140.98 446.316 141.204 446.671 141.542C447.222 142.278 446.395 143.381 445.567 143.657C442.809 144.76 439.315 142.737 436.832 144.393C435.453 145.312 434.993 147.151 433.89 148.346C432.51 150.002 430.212 150.737 428.005 150.921C425.817 150.994 423.636 151.209 421.476 151.565C418.258 152.3 414.856 154.415 411.913 152.76C411.628 152.596 411.378 152.378 411.178 152.116C410.81 151.473 411.27 150.645 411.637 149.91C412.658 147.992 413.105 145.822 412.925 143.657C412.833 140.623 412.741 140.898 415.775 139.795C420.189 138.324 424.786 137.036 429.476 137.404Z",
    fill: "url(#paint1_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.614 294.365L433.338 300.71L444.464 300.618L445.2 291.883L433.614 294.365Z",
    fill: "url(#paint2_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.338 300.71L444.464 300.618L447.866 305.032C447.866 305.032 462.671 310.365 465.429 317.629C468.188 324.893 467.636 328.663 467.636 328.663L428.649 315.882L433.338 300.71Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.145 194.506C352.145 194.506 430.395 195.058 436.832 199.563C454.67 211.977 449.153 292.342 449.153 292.342L433.246 296.94L420.373 228.712L352.145 194.506Z",
    fill: "#25233A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.966 287.653H257.711V333.261H191.966V287.653Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.195 289.032H218.999V332.985H196.195V289.032Z",
    fill: "url(#paint3_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.46 333.261H253.205V384.018H187.46V333.261Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.46 333.261H253.205V384.018H187.46V333.261Z",
    fill: "url(#paint4_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.459 287.653H231.32V296.94H219.459V287.653Z",
    fill: "url(#paint5_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.023 333.077H224.884V342.364H213.023V333.077Z",
    fill: "url(#paint6_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.344 296.94H226.263V333.077H225.344V296.94Z",
    fill: "url(#paint7_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.999 342.364H219.919V378.501H218.999V342.364Z",
    fill: "url(#paint8_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.885 172.438H271.227V226.781H192.885V172.438Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.885 172.438H271.227V226.781H192.885V172.438Z",
    fill: "url(#paint9_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.46 226.689H265.802V287.193H187.46V226.689Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.46 226.689H265.802V287.193H187.46V226.689Z",
    fill: "url(#paint10_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62 172.438H239.78V183.472H225.62V172.438Z",
    fill: "url(#paint11_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.896 226.505H232.056V237.539H217.896V226.505Z",
    fill: "url(#paint12_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.608 183.472H233.711V226.505H232.608V183.472Z",
    fill: "url(#paint13_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.068 237.539H226.171V280.573H225.068V237.539Z",
    fill: "url(#paint14_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.91 250.413H196.287V312.388H106.91V250.413Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.195 287.193V312.296H106.91V250.413H187.46V287.193H196.195Z",
    fill: "url(#paint15_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.46 250.413H196.195V287.285H187.46V250.413Z",
    fill: "url(#paint16_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4629 312.296H172.84V381.351H83.4629V312.296Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4629 312.296H172.84V381.351H83.4629V312.296Z",
    fill: "url(#paint17_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.151 250.413H160.242V263.01H144.151V250.413Z",
    fill: "url(#paint18_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.312 312.112H134.404V324.709H118.312V312.112Z",
    fill: "url(#paint19_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.242 263.01H153.53V312.112H152.242V263.01Z",
    fill: "url(#paint20_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.404 324.709H127.599V373.811H126.404V324.709Z",
    fill: "url(#paint21_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.589 119.198H191.965V181.173H102.589V119.198Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.589 119.198H191.965V181.173H102.589V119.198Z",
    fill: "url(#paint22_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4281 181.173H185.805V250.229H96.4281V181.173Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4281 181.173H185.805V250.229H96.4281V181.173Z",
    fill: "url(#paint23_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.921 119.198H156.012V131.795H139.921V119.198Z",
    fill: "url(#paint24_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.186 180.897H147.277V193.495H131.186V180.897Z",
    fill: "url(#paint25_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.013 131.795H149.208V180.897H148.013V131.795Z",
    fill: "url(#paint26_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.277 193.495H140.472V242.597H139.277V193.495Z",
    fill: "url(#paint27_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M185.805 213.172V250.137C185.805 250.137 172.38 232.942 172.931 223.655C173.483 214.368 185.805 213.172 185.805 213.172Z",
    fill: "url(#paint28_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.366 263.929L242.722 287.193H187.46V226.689H192.885V219.425L201.068 226.689L225.068 247.746L226.079 248.757L243.366 263.929Z",
    fill: "url(#paint29_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.974 231.195H424.878V330.962H280.974V231.195Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.974 231.195H424.878V330.962H280.974V231.195Z",
    fill: "url(#paint30_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.366 330.962H387.27V442.131H243.366V330.962Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.366 330.962H387.27V442.131H243.366V330.962Z",
    fill: "url(#paint31_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.111 231.195H367.041V251.516H341.111V231.195Z",
    fill: "url(#paint32_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.365 330.502H325.295V350.823H299.365V330.502Z",
    fill: "url(#paint33_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.076 251.424H356.099V330.502H354.076V251.424Z",
    fill: "url(#paint34_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.514 350.823H314.537V429.902H312.514V350.823Z",
    fill: "url(#paint35_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4 442.131H218.631V252.987C218.635 251.688 218.895 250.403 219.396 249.205C219.897 248.007 220.631 246.92 221.553 246.006C222.476 245.091 223.57 244.368 224.773 243.878C225.975 243.388 227.263 243.14 228.562 243.148C231.175 243.162 233.679 244.201 235.536 246.04C237.392 247.88 238.454 250.374 238.492 252.987V442.131H238.4Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.792 259.883C230.619 261.559 227.87 262.307 225.148 261.962C222.425 261.618 219.95 260.209 218.263 258.044L191.965 224.39C190.289 222.217 189.542 219.469 189.886 216.747C190.231 214.024 191.64 211.549 193.804 209.862C195.964 208.171 198.706 207.406 201.429 207.733C204.153 208.061 206.635 209.454 208.332 211.609L234.631 245.263C235.481 246.34 236.108 247.574 236.476 248.895C236.844 250.217 236.945 251.598 236.774 252.959C236.603 254.319 236.163 255.632 235.479 256.821C234.795 258.01 233.882 259.051 232.792 259.883Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.221 451.326C471.221 453.765 470.252 456.104 468.528 457.828C466.804 459.553 464.465 460.522 462.026 460.522H237.389C232.502 460.526 227.812 458.593 224.347 455.146C220.883 451.699 218.926 447.019 218.907 442.131H461.934C463.149 442.119 464.355 442.348 465.481 442.805C466.608 443.261 467.632 443.937 468.496 444.792C469.359 445.647 470.045 446.665 470.513 447.786C470.981 448.908 471.221 450.111 471.221 451.326Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.221 451.326H237.389C234.15 451.333 230.966 450.486 228.157 448.872C225.349 447.258 223.015 444.933 221.389 442.131H461.934C463.148 442.125 464.351 442.358 465.474 442.817C466.598 443.276 467.62 443.951 468.482 444.805C469.345 445.659 470.03 446.674 470.5 447.793C470.97 448.912 471.215 450.113 471.221 451.326Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4 442.131H218.631V252.987C218.635 251.688 218.895 250.403 219.396 249.205C219.897 248.007 220.631 246.92 221.553 246.006C222.476 245.091 223.57 244.368 224.773 243.878C225.975 243.388 227.263 243.14 228.562 243.148C231.175 243.162 233.679 244.201 235.536 246.04C237.392 247.88 238.454 250.374 238.492 252.987V442.131H238.4Z",
    fill: "url(#paint36_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.792 259.883C230.619 261.559 227.87 262.307 225.148 261.962C222.425 261.618 219.95 260.209 218.263 258.044L191.965 224.39C190.289 222.217 189.542 219.469 189.886 216.747C190.231 214.024 191.64 211.549 193.804 209.862C195.964 208.171 198.706 207.406 201.429 207.733C204.153 208.061 206.635 209.454 208.332 211.609L234.631 245.263C235.481 246.34 236.108 247.574 236.476 248.895C236.844 250.217 236.945 251.598 236.774 252.959C236.603 254.319 236.163 255.632 235.479 256.821C234.795 258.01 233.882 259.051 232.792 259.883Z",
    fill: "url(#paint37_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.221 451.326C471.221 453.765 470.252 456.104 468.528 457.828C466.804 459.553 464.465 460.522 462.026 460.522H237.389C232.502 460.526 227.812 458.593 224.347 455.146C220.883 451.699 218.926 447.019 218.907 442.131H461.934C463.149 442.119 464.355 442.348 465.481 442.805C466.608 443.261 467.632 443.937 468.496 444.792C469.359 445.647 470.045 446.665 470.513 447.786C470.981 448.908 471.221 450.111 471.221 451.326Z",
    fill: "url(#paint38_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.221 451.326H237.389C234.15 451.333 230.966 450.486 228.157 448.872C225.349 447.258 223.015 444.933 221.389 442.131H461.934C463.148 442.125 464.351 442.358 465.474 442.817C466.598 443.276 467.62 443.951 468.482 444.805C469.345 445.659 470.03 446.674 470.5 447.793C470.97 448.912 471.215 450.113 471.221 451.326Z",
    fill: "url(#paint39_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.884 492.665C275.845 486.704 275.845 477.039 269.884 471.078C263.924 465.118 254.259 465.118 248.298 471.078C242.337 477.039 242.337 486.704 248.298 492.665C254.259 498.626 263.924 498.626 269.884 492.665Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M259.182 486.912C261.721 486.912 263.78 484.853 263.78 482.314C263.78 479.775 261.721 477.716 259.182 477.716C256.643 477.716 254.585 479.775 254.585 482.314C254.585 484.853 256.643 486.912 259.182 486.912Z",
    fill: "#1D2741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.044 480.383H253.113V460.522H273.066L263.044 480.383Z",
    fill: "url(#paint40_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.177 497.118C435.607 497.118 442.441 490.284 442.441 481.854C442.441 473.424 435.607 466.59 427.177 466.59C418.747 466.59 411.913 473.424 411.913 481.854C411.913 490.284 418.747 497.118 427.177 497.118Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.169 484.321C275.52 475.999 269.869 468.159 261.548 466.808C253.227 465.457 245.387 471.108 244.036 479.429C242.685 487.75 248.336 495.591 256.657 496.942C264.978 498.292 272.819 492.642 274.169 484.321Z",
    fill: "url(#paint41_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.177 497.118C435.607 497.118 442.441 490.284 442.441 481.854C442.441 473.424 435.607 466.59 427.177 466.59C418.747 466.59 411.913 473.424 411.913 481.854C411.913 490.284 418.747 497.118 427.177 497.118Z",
    fill: "url(#paint42_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M422.488 482.314C422.488 483.223 422.757 484.112 423.263 484.868C423.768 485.624 424.486 486.214 425.326 486.562C426.166 486.91 427.09 487.001 427.982 486.823C428.874 486.646 429.693 486.208 430.336 485.565C430.979 484.922 431.417 484.103 431.594 483.211C431.772 482.319 431.681 481.395 431.333 480.555C430.985 479.714 430.396 478.996 429.64 478.491C428.883 477.986 427.995 477.716 427.085 477.716C425.866 477.716 424.696 478.201 423.834 479.063C422.972 479.925 422.488 481.095 422.488 482.314Z",
    fill: "#1D2741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.223 480.383H433.246V460.522H413.292L423.223 480.383Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.044 480.383H253.113V460.522H273.066L263.044 480.383Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.044 480.383H253.113V460.522H273.066L263.044 480.383Z",
    fill: "url(#paint43_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.223 480.383H433.246V460.522H413.292L423.223 480.383Z",
    fill: "url(#paint44_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M280.974 233.677H293.756V330.594H280.974V233.677Z",
    fill: "url(#paint45_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243.734 332.065H256.515V439.556H243.734V332.065Z",
    fill: "url(#paint46_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.157 193.495C337.157 193.495 332.283 222.422 352.972 228.859C373.661 235.296 424.878 231.158 424.878 231.158L471.957 286.88L483.635 271.157L441.154 212.86C433.084 204.294 422.089 199.075 410.35 198.239L337.157 193.495Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.049 286.917L476.923 290.963L483.635 282.136L479.681 276.619L472.049 286.917Z",
    fill: "url(#paint47_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.923 290.963L483.636 282.136H489.153C489.153 282.136 502.394 273.676 509.934 275.975C517.474 278.274 520.048 281.032 520.048 281.032L486.026 304.02L476.923 290.963Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.338 300.71L444.464 300.618L447.866 305.032C447.866 305.032 462.671 310.365 465.429 317.629C468.188 324.893 467.636 328.663 467.636 328.663L428.649 315.882L433.338 300.71Z",
    fill: "url(#paint48_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.923 290.963L483.636 282.136H489.153C489.153 282.136 502.394 273.676 509.934 275.975C517.474 278.274 520.048 281.032 520.048 281.032L486.026 304.02L476.923 290.963Z",
    fill: "url(#paint49_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.834 195.242H336.973L336.421 194.966C334.766 194.046 330.536 190.552 330.996 181.173C331.364 174.369 337.433 149.45 342.398 129.956C345.892 116.072 348.927 104.853 348.927 104.853C348.927 104.853 355.363 87.9344 366.122 83.5207C370.167 81.8656 375.317 79.107 380.926 80.1185C390.213 81.9575 399.776 90.3251 401.155 101.635C402.258 111.106 388.834 195.242 388.834 195.242Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.834 195.242H336.973L336.421 194.966C334.766 194.046 330.536 190.552 330.996 181.173C331.364 174.369 337.433 149.45 342.398 129.956C345.892 116.072 348.927 104.853 348.927 104.853C348.927 104.853 355.363 87.9344 366.122 83.5207C370.167 81.8656 375.317 79.107 380.926 80.1185C390.213 81.9575 399.776 90.3251 401.155 101.635C402.258 111.106 388.834 195.242 388.834 195.242Z",
    fill: "url(#paint50_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.087 153.459C355.087 153.459 343.318 184.539 352.145 194.469L336.421 194.929C334.766 194.01 330.536 190.515 330.996 181.136C331.364 174.332 337.433 149.413 342.398 129.919L363.179 101.543L355.087 153.459Z",
    fill: "url(#paint51_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.834 80.0266L386.351 64.8546C386.351 64.8546 392.787 40.4875 407.592 39.2002C422.396 37.9128 434.809 48.6712 428.556 65.7741C422.304 82.8771 419.177 85.5437 413.109 86.6471C407.04 87.7505 401.339 84.9 401.339 84.9L396.006 92.9917C396.098 92.9917 394.351 97.6813 380.834 80.0266Z",
    fill: "url(#paint52_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.719 97.5892C354.719 97.5892 329.525 134.002 330.904 143.473C332.559 154.599 380.19 156.346 399.684 156.898C402.19 157.002 404.658 156.26 406.692 154.793C408.727 153.325 410.209 151.217 410.902 148.806V148.714C411.747 145.837 411.419 142.741 409.989 140.105C408.559 137.469 406.143 135.506 403.27 134.646C402.729 134.479 402.175 134.356 401.614 134.278L368.972 129.864L384.328 100.624C388.282 88.2102 373.569 78.0956 363.455 86.2792C359.842 89.4522 356.876 93.2924 354.719 97.5892Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.752 139.979L409.706 139.519L406.948 154.599H411.453L413.752 139.979Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.441 158.001C426.441 158.001 422.12 161.404 424.143 165.082C426.165 168.76 433.062 168.944 433.062 168.944C433.062 168.944 438.671 158.921 426.441 158.001Z",
    fill: "url(#paint53_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.752 139.979L409.706 139.519L406.948 154.599H411.453L413.752 139.979Z",
    fill: "url(#paint54_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.868 60.9926C398.58 60.4409 399.684 58.2341 398.856 57.1307C398.029 56.0273 396.557 56.6709 395.638 57.4985C394.734 58.3544 394.078 59.4381 393.738 60.6355C393.398 61.833 393.387 63.0999 393.707 64.3029C394.015 65.0601 394.141 65.8789 394.075 66.6936C393.615 68.3488 391.408 68.5327 389.753 68.1649C388.098 67.7971 386.259 67.0614 384.88 67.981C383.684 65.958 384.512 63.3834 385.431 61.2685C387.062 57.4234 389.032 53.7308 391.316 50.2343C391.867 49.5008 392.244 48.652 392.42 47.7517C392.603 46.3724 391.776 45.177 391.316 43.9816C388.925 38.1887 392.236 31.1084 397.753 28.0741C403.27 25.0397 410.166 25.5914 415.867 28.0741C417.982 28.9936 420.005 30.1889 422.212 30.6487C425.522 31.2924 428.924 30.3728 432.327 30.3728C434.958 30.4648 437.53 31.1795 439.832 32.4583C442.134 33.737 444.099 35.5433 445.568 37.7289C446.982 39.968 447.845 42.5111 448.085 45.1488C448.325 47.7865 447.935 50.4434 446.947 52.9009C445.751 55.7514 442.809 58.6019 439.958 57.5905C438.763 57.2226 437.844 56.2112 436.74 55.5675C435.637 54.9239 433.982 54.8319 433.246 55.8434C433.085 56.1047 432.9 56.3509 432.694 56.579C431.683 57.3146 430.855 55.5675 430.304 54.5561C429.016 52.0734 425.522 52.1653 422.764 52.2573C420.082 52.3174 417.401 52.1017 414.764 51.6136C412.833 51.2458 410.258 49.9585 408.327 50.5102C405.936 50.878 400.144 61.0846 399.868 60.9926Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.923 128.117L471.314 130.968L416.879 170.231L414.764 167.196L468.923 128.117Z",
    fill: "url(#paint55_linear_7_987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.442 163.426C426.442 163.426 427.361 166.461 432.143 164.898C436.924 163.334 445.476 158.277 446.211 156.99C446.947 155.703 454.303 148.071 453.843 143.749L426.442 163.426Z",
    fill: "url(#paint56_linear_7_987)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_987",
    x: 0,
    y: 0,
    width: 564.166,
    height: 604.473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_987",
    x1: 118.101,
    y1: 264.582,
    x2: 634.16,
    y2: 785.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_987",
    x1: 411.122,
    y1: 145.358,
    x2: 446.882,
    y2: 145.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_987",
    x1: 447.803,
    y1: 297.357,
    x2: 436.385,
    y2: 295.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_987",
    x1: 198.733,
    y1: 308.526,
    x2: 256.727,
    y2: 324.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_987",
    x1: 216.296,
    y1: 351.853,
    x2: 254.271,
    y2: 415.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7_987",
    x1: 219.44,
    y1: 292.296,
    x2: 231.284,
    y2: 292.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7_987",
    x1: 231.698,
    y1: 330.879,
    x2: 187.681,
    y2: 354.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7_987",
    x1: 239.909,
    y1: 311.799,
    x2: 222.659,
    y2: 315.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7_987",
    x1: 233.546,
    y1: 357.223,
    x2: 216.296,
    y2: 361.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7_987",
    x1: 212.084,
    y1: 177.633,
    x2: 283.558,
    y2: 256.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7_987",
    x1: 193.381,
    y1: 217.751,
    x2: 279.154,
    y2: 318.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7_987",
    x1: 235.532,
    y1: -158.413,
    x2: 228.433,
    y2: 684.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7_987",
    x1: 228.268,
    y1: -158.468,
    x2: 221.169,
    y2: 684.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7_987",
    x1: 234.015,
    y1: 172.585,
    x2: 229.868,
    y2: 329.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7_987",
    x1: 242.373,
    y1: 255.24,
    x2: 221.822,
    y2: 259.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7_987",
    x1: 115.002,
    y1: 243.525,
    x2: 183.037,
    y2: 323.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7_987",
    x1: 174.43,
    y1: 248.399,
    x2: 211.808,
    y2: 292.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7_987",
    x1: 111.618,
    y1: 329.739,
    x2: 187.699,
    y2: 408.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7_987",
    x1: 155.7,
    y1: -159.084,
    x2: 148.61,
    y2: 683.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7_987",
    x1: 130.386,
    y1: -159.295,
    x2: 123.287,
    y2: 683.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7_987",
    x1: 154.274,
    y1: 238.569,
    x2: 149.098,
    y2: 421.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7_987",
    x1: 127.305,
    y1: 304.572,
    x2: 126.266,
    y2: 458.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7_987",
    x1: 101.43,
    y1: 118.094,
    x2: 213.749,
    y2: 196.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7_987",
    x1: 87.4905,
    y1: 171.868,
    x2: 204.903,
    y2: 267.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7_987",
    x1: 150.367,
    y1: -159.13,
    x2: 143.268,
    y2: 683.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7_987",
    x1: 142.146,
    y1: -159.194,
    x2: 135.057,
    y2: 683.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7_987",
    x1: 148.224,
    y1: 122.821,
    x2: 150.302,
    y2: 303.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7_987",
    x1: 140.279,
    y1: 176.438,
    x2: 138.21,
    y2: 390.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7_987",
    x1: 159.479,
    y1: 230.431,
    x2: 237.408,
    y2: 234.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7_987",
    x1: 222.236,
    y1: 245.613,
    x2: 168.039,
    y2: 331.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7_987",
    x1: 325.672,
    y1: 239.387,
    x2: 412.456,
    y2: 372.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7_987",
    x1: 243.366,
    y1: 386.546,
    x2: 387.27,
    y2: 386.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7_987",
    x1: 357.432,
    y1: -157.383,
    x2: 350.343,
    y2: 685.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7_987",
    x1: 316.532,
    y1: -157.723,
    x2: 309.433,
    y2: 684.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7_987",
    x1: 353.993,
    y1: 199.931,
    x2: 359.17,
    y2: 630.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7_987",
    x1: 312.146,
    y1: 275.874,
    x2: 317.323,
    y2: 706.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7_987",
    x1: 218.576,
    y1: 342.64,
    x2: 238.382,
    y2: 342.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7_987",
    x1: 189.804,
    y1: 234.854,
    x2: 236.865,
    y2: 234.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7_987",
    x1: 218.907,
    y1: 451.326,
    x2: 471.221,
    y2: 451.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7_987",
    x1: 221.389,
    y1: 446.729,
    x2: 471.221,
    y2: 446.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7_987",
    x1: 253.113,
    y1: 470.452,
    x2: 273.066,
    y2: 470.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7_987",
    x1: 258.518,
    y1: 541.447,
    x2: 259.299,
    y2: 466.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7_987",
    x1: 426.552,
    y1: 543.167,
    x2: 427.324,
    y2: 467.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7_987",
    x1: 249.977,
    y1: 465.901,
    x2: 269.848,
    y2: 472.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7_987",
    x1: 413.292,
    y1: 470.452,
    x2: 433.246,
    y2: 470.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7_987",
    x1: 314.766,
    y1: 254.513,
    x2: 259.963,
    y2: 309.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7_987",
    x1: 280.165,
    y1: 355.522,
    x2: 220.084,
    y2: 416.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7FC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7_987",
    x1: 482.569,
    y1: 279.488,
    x2: 473.631,
    y2: 288.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7_987",
    x1: 447.407,
    y1: 314.162,
    x2: 441.457,
    y2: 257.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7_987",
    x1: 500.849,
    y1: 308.572,
    x2: 494.89,
    y2: 251.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7_987",
    x1: 400.226,
    y1: 135.381,
    x2: 251.1,
    y2: 154.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7_987",
    x1: 354.618,
    y1: 148.604,
    x2: 286.961,
    y2: 161.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7_987",
    x1: 377.552,
    y1: 69.2565,
    x2: 428.966,
    y2: 63.0244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7_987",
    x1: 429.145,
    y1: 156.098,
    x2: 428.501,
    y2: 183.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7_987",
    x1: 417.485,
    y1: 148.144,
    x2: 386.157,
    y2: 144.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7_987",
    x1: 438.542,
    y1: 141.441,
    x2: 444.455,
    y2: 151.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#65D5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5DB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#51859F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#404059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3F3D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7_987",
    x1: 446.147,
    y1: 147.409,
    x2: 417.044,
    y2: 185.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogistics);
export default __webpack_public_path__ + "static/media/illustrationLogistics.2574d55e67b3261ddb776b2b272d890c.svg";
export { ForwardRef as ReactComponent };